export default "__VITE_ASSET__C2jIgGCX__"